<!-- eslint-disable -->
<template>
    <div>
        <b-overlay :show="show" rounded="sm">
            <template #overlay>
                <div class="text-center">
                    <div class="h2 mb-0">
                        <b-icon-watch font-scale="3" animation="cylon" />
                    </div>
                    <h2 class="text-dark">Procesando ....</h2>
                </div>
            </template>
            <div v-if="balance <= 0">
                <b-alert variant="warning" show class="mb-0">
                    <div class="alert-body">
                        <feather-icon icon="InfoIcon" class="mr-50" />
                        No tiene un Balance pendiente de pago. Gracias por
                        mantener su cuenta al día. 👋
                    </div>
                </b-alert>
            </div>
            <div v-else>
                <b-row>
                    <b-col md="12">
                        <p class="text-justify">
                            Estimado, {{ contract.apenom }}
                            al continuar acepta los
                            <b-link :href="termsUrl" target="_blank">
                                Terminos y Condiciones
                            </b-link>
                            y
                            <b-link :href="privacyUrl" target="_blank">
                                Proteccion de Datos Personales
                            </b-link>
                            de la plataforma.
                            <br />
                            Puede obtener más información sobre el uso de la
                            Plataforma y Nuvei consultando la guia de
                            <b-link :href="faqUrl" target="_blank">
                                Preguntas Frecuentes
                            </b-link>
                        </p>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col md="12">
                        <b-form-input v-model="amount" size="lg" disabled />
                    </b-col>
                    <b-col md="12">
                        <b-form-group label="Aceptar" label-for="tt-accept">
                            <b-form-checkbox
                                v-model="accept"
                                class="mr-0 mt-1"
                                name="tt-accept"
                                switch
                                inline
                            />
                        </b-form-group>
                    </b-col>
                    <b-col md="12" class="mt-1">
                        <b-button
                            variant="primary"
                            block
                            size="lg"
                            :disabled="amount > 0 ? false : true"
                            hidden
                            @click="save()"
                        >
                            Continuar
                        </b-button>
                    </b-col>
                    <b-col md="12" class="mt-1">
                        <b-button
                            variant="success"
                            block
                            size="lg"
                            :disabled="!accept"
                            @click="gatewayReference()"
                        >
                            Pagar con Nuvei
                        </b-button>
                    </b-col>
                    <b-col md="12" class="mt-1">
                        <b-form-group class="mt-3">
                            <b-img
                                fluid
                                center
                                class="mt-1"
                                src="https://clientes-tt.s3.amazonaws.com/rapinet/portal_clientes_pasarela/franquicias_tarjetas.jpeg"
                            />
                        </b-form-group>
                    </b-col>
                </b-row>
            </div>
        </b-overlay>
        <div id="response" style="display: none" />
    </div>
</template>

<script>
/* eslint-disable */
import paymentMixin from '@/mixins/paymentMixin'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import {
    BAlert,
    BButton,
    BCol,
    BFormCheckbox,
    BFormGroup,
    BFormInput,
    BIconWatch,
    BImg,
    BLink,
    BOverlay,
    BRow,
} from 'bootstrap-vue'

export default {
    components: {
        BOverlay,
        BIconWatch,
        BAlert,
        BRow,
        BCol,
        BLink,
        BFormGroup,
        BFormInput,
        BFormCheckbox,
        BButton,
        BImg,
    },
    mixins: [paymentMixin],
    props: {
        contract: {
            type: Object,
            default: () => {},
            required: true,
        },
    },
    setup() {
        const termsUrl = process.env.VUE_APP_TERMS_URL
        const privacyUrl = process.env.VUE_APP_PRIVACY_URL
        const faqUrl = process.env.VUE_APP_FAQ_URL
        const envMode = process.env.VUE_APP_NUVEI_ENV_MODE

        return { termsUrl, privacyUrl, faqUrl, envMode }
    },
    data() {
        return {
            show: false,
            userData: JSON.parse(localStorage.getItem('userData')),
            balance: 0,
            amount: 0,
            disabled: false,
            accept: false,
            program: {
                title: 'Pago de Servicio',
                id: 0,
                price: 0,
            },
            paymentCheckoutInstance: null,
            contractid: null,
        }
    },
    created() {
        this.calculateAmount()
    },
    methods: {
        searchBalance() {
            this.show = true
            this.$http
                .get('/contrato-balance', {
                    params: {
                        idcontrato: this.contract.idcontrato,
                        opresumen: 1,
                    },
                })
                .then((response) => {
                    this.show = false
                    if (response.data) {
                        this.balance = response.data.data
                        this.amount = response.data.data
                        this.program.price = response.data.data
                        this.program.id = this.contract.idcontrato
                    }
                })
                .catch((error) => {
                    this.show = false
                })
        },

        save() {
            if (!this.accept) {
                this.$toast({
                    component: ToastificationContent,
                    props: {
                        title: 'Debe Aceptar los Terminos y Condiciones',
                        variant: 'danger',
                        icon: 'XIcon',
                    },
                })

                return
            }

            this.show = true

            this.$http
                .post('p2p-payment', {
                    idcontrato: this.contract.idcontrato,
                    idusuario: this.userData.id,
                })
                .then((response) => {
                    this.show = false
                    const { message } = response.data
                    const { process_url } = response.data

                    window.open(process_url, '_blank')

                    this.$swal({
                        title: 'Éxito',
                        text: message,
                        icon: 'success',
                        customClass: {
                            confirmButton: 'btn btn-success',
                        },
                        buttonsStyling: false,
                    })
                })
                .catch((error) => {
                    this.show = false
                    this.$swal({
                        title: 'Error',
                        text: error.response.data.error,
                        icon: 'error',
                        customClass: {
                            confirmButton: 'btn btn-danger',
                        },
                        buttonsStyling: false,
                    })
                })
        },

        gatewayReference() {
            this.show = true

            const payload = {
                idcontrato: this.contractid,
                idusuario: this.userData.id,
                amount: this.amount,
                items: JSON.stringify(this.contract.selectedItems),
            }

            this.$http
                .post(`/nuvei/reference`, payload)
                .then((response) => {
                    const { reference, id } = response.data.data

                    if (!reference) {
                        this.$swal({
                            title: 'Advertencia!',
                            text: 'No se pudo crear una sesión de pago, intente nuevamente',
                            icon: 'warning',
                            customClass: {
                                confirmButton: 'btn btn-danger',
                            },
                            buttonsStyling: false,
                        })
                        this.show = false

                        return
                    }

                    this.createReference(reference, id)

                    this.$root.$emit('bv::hide::modal', 'modal-payment')

                    this.$toast({
                        component: ToastificationContent,
                        props: {
                            title: 'Datos procesados correctamente!',
                            variant: 'success',
                            icon: 'CheckIcon',
                        },
                    })
                })
                .catch((err) => {
                    this.$swal({
                        title: 'Error!',
                        text: 'Ocurrió un error al procesar la solicitud',
                        icon: 'error',
                        customClass: {
                            confirmButton: 'btn btn-danger',
                        },
                        buttonsStyling: false,
                    })
                })
                .finally(() => {
                    this.show = false
                })
        },

        async createReference(reference, id) {
            if (!reference) return

            this.show = true

            try {
                const PaymentCheckout = await this.waitForPaymentCheckout()

                let paymentCheckout = null
                const self = this

                paymentCheckout = new PaymentCheckout.modal({
                    env_mode: this.envMode,
                    onOpen() {},
                    onClose() {},
                    onResponse(response) {
                        self.updateReference(id, response)
                        document.getElementById('response').innerHTML =
                            JSON.stringify(response)
                    },
                    onError(error) {
                        self.show = false
                    },
                })

                if (!paymentCheckout) {
                    throw new Error(
                        'No se pudo crear la instancia de PaymentCheckout'
                    )
                }

                this.paymentCheckoutInstance = paymentCheckout

                setTimeout(() => {
                    if (paymentCheckout) {
                        try {
                            paymentCheckout.open({
                                reference,
                            })
                        } catch (openError) {
                            self.$swal({
                                title: 'Error!',
                                text: 'No se pudo abrir el modal de pago. Por favor, intente nuevamente.',
                                icon: 'error',
                                customClass: {
                                    confirmButton: 'btn btn-danger',
                                },
                                buttonsStyling: false,
                            })
                        }
                    }
                    this.show = false
                }, 2000)
            } catch (error) {
                this.$swal({
                    title: 'Error!',
                    text: 'No se pudo inicializar el método de pago. Por favor, recargue la página e intente nuevamente.',
                    icon: 'error',
                    customClass: {
                        confirmButton: 'btn btn-danger',
                    },
                    buttonsStyling: false,
                })
                this.show = false

                return
            }

            window.addEventListener('popstate', function () {
                if (paymentCheckout) {
                    paymentCheckout.close()
                }
            })
        },

        updateReference(id, response) {
            if (!response || typeof response !== 'object') {
                this.$swal({
                    title: 'Error!',
                    text: 'La respuesta del procesador de pagos no es válida.',
                    icon: 'error',
                    customClass: {
                        confirmButton: 'btn btn-danger',
                    },
                    buttonsStyling: false,
                })

                return
            }

            this.show = true

            this.$http
                .put(`/nuvei/payment/${id}`, {
                    response,
                })
                .then(() => {
                    if (this.paymentCheckoutInstance) {
                        this.paymentCheckoutInstance.close()
                    }

                    this.$router.push('perfil/payment')
                })
                .catch((err) => {
                    this.$swal({
                        title: 'Error!',
                        text: 'Ocurrió un error al procesar la solicitud',
                        icon: 'error',
                        customClass: {
                            confirmButton: 'btn btn-danger',
                        },
                        buttonsStyling: false,
                    })
                })
                .finally(() => {
                    this.show = false
                })
        },

        calculateAmount() {
            let totalAmount = 0

            if (this.contract && Array.isArray(this.contract.selectedItems)) {
                this.contract.selectedItems.forEach((item) => {
                    totalAmount += parseFloat(item.saldo || 0)
                    this.contractid = item.idcontrato
                })
            }

            this.amount = this.roundNumber(totalAmount, 2)
            this.program.price = this.amount
            this.program.id = this.contractid
            this.balance = this.amount
        },

        roundNumber(value, precision) {
            if (Number.isInteger(precision)) {
                // eslint-disable-next-line no-restricted-properties
                const shift = Math.pow(10, precision)

                return Math.round(value * shift + 0.00000000000001) / shift
            }

            return Math.round(value)
        },
    },
}
</script>
